export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="font-body text-sm text-neutral-dark">
            © {currentYear} by Minute Man Air Field
          </p>
        </div>
      </div>
    </footer>
  );
}